import ApplicationComponent from "legacy/ApplicationComponent"
import DeprecatedOldReactAdapterComponentContainer from "legacy/dangerous/DeprecatedOldReactAdapterComponentContainer"
import PropTypes from "prop-types"
import React from "react"

class ReservationNightsSection extends ApplicationComponent {
  render() {
    return (
      <DeprecatedOldReactAdapterComponentContainer id="nights-section-mbm">
        <p className="mb-3 text-xs md:text-sm">
          {this.props.isDayTrip
            ? "Day Trip"
            : `${this.props.nights} ${this.pluralize(
                "Night",
                this.props.nights
              )}`}
        </p>
      </DeprecatedOldReactAdapterComponentContainer>
    )
  }

  // Helper method to handle pluralization
  pluralize(word, count) {
    return count === 1 ? word : `${word}s`
  }
}

ReservationNightsSection.propTypes = {
  nights: PropTypes.number.isRequired,
  isDayTrip: PropTypes.bool,
}

export default ReservationNightsSection
